const initialState = {
  loading: false,
  success: null,
  error: null
}

function updateCategoryReducer(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_CATEGORY_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'UPDATE_CATEGORY_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'UPDATE_CATEGORY_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default updateCategoryReducer